import { render, staticRenderFns } from "./stepTwo.vue?vue&type=template&id=10b4e3d2&scoped=true"
import script from "./stepTwo.vue?vue&type=script&lang=js"
export * from "./stepTwo.vue?vue&type=script&lang=js"
import style0 from "./stepTwo.vue?vue&type=style&index=0&id=10b4e3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b4e3d2",
  null
  
)

export default component.exports